import axios from 'axios';
import { getErrorObject } from '../utils/apiUtils';
import { setErrors } from './errorHandler';
import { NO_DATA_FOUND } from '../constants/errorMessage';
import { getManagementDashboardSearchBody } from 'utils/dashboardUtil';

export const GET_POWER_BI_DASHBOARD_URL_LOADING = '@@dashboard/GET_POWER_BI_DASHBOARD_URL_LOADING';
export const GET_POWER_BI_DASHBOARD_URL_SUCCESS = '@@dashboard/GET_POWER_BI_DASHBOARD_URL_SUCCESS';
export const GET_POWER_BI_DASHBOARD_URL_FAILURE = '@@dashboard/GET_POWER_BI_DASHBOARD_URL_FAILURE';

export const getPowerBIDashboardDetails = () => async (dispatch) => {
  dispatch({ type: GET_POWER_BI_DASHBOARD_URL_LOADING });
  try {
    const response = await axios.get('/app/customer/dashboard/powerbi/action/geturl');
    if (response?.data?.ErrorCount > 0) {
      if (response?.data?.Errors[0].Message !== NO_DATA_FOUND) {
        dispatch(setErrors(response?.data?.Errors));
      }
      dispatch({
        type: GET_POWER_BI_DASHBOARD_URL_FAILURE,
        payload: {},
      });
    } else {
      dispatch({
        type: GET_POWER_BI_DASHBOARD_URL_SUCCESS,
        payload: response.data,
      });
    }
  } catch (err) {
    dispatch({
      type: GET_POWER_BI_DASHBOARD_URL_FAILURE,
      payload: getErrorObject(err),
    });
  }
};


export const GET_MANAGEMENT_DASHBOARD_URL_LOADING = '@@dashboard/GET_MANAGEMENT_DASHBOARD_URL_LOADING';
export const GET_MANAGEMENT_DASHBOARD_URL_SUCCESS = '@@dashboard/GET_MANAGEMENT_DASHBOARD_URL_SUCCESS';
export const GET_MANAGEMENT_DASHBOARD_URL_FAILURE = '@@dashboard/GET_MANAGEMENT_DASHBOARD_URL_FAILURE';

export const getManagementDashboardDetails = () => async (dispatch) => {
  dispatch({ type: GET_MANAGEMENT_DASHBOARD_URL_LOADING });
  try {
    const body = getManagementDashboardSearchBody();
    const response = await axios.post('/app/customer/powerbi/dashboard/configuration/search', body);
    if (response?.data?.ErrorCount > 0) {
      if (response?.data?.Errors[0].Message !== NO_DATA_FOUND) {
        dispatch(setErrors(response?.data?.Errors));
      }
      dispatch({
        type: GET_MANAGEMENT_DASHBOARD_URL_FAILURE,
        payload: {},
      });
    } else {
      dispatch({
        type: GET_MANAGEMENT_DASHBOARD_URL_SUCCESS,
        payload: response.data,
      });
    }
  } catch (err) {
    dispatch({
      type: GET_MANAGEMENT_DASHBOARD_URL_FAILURE,
      payload: getErrorObject(err),
    });
  }
};
